import React, {
	useEffect,
	useRef,
	useState,
} from 'react';

import {
	PDFReceiverMessages,
	PdfSenderMessages,
	ReceiverTextMessages,
	RecevicerImageMessage,
	SenderImageMessage,
	SenderTextMessages
} from './messages';

import {
	getCurrentTimeCanada,
} from '../../utils/helper/helper';

import {
	useCustomDispatch,
	useCustomLocation
} from '../../hooks';

import {
	useCustomDataStoringStates,
	useCustomLoadingStates
} from '../../hooks/customStates';

import {
	closeChatbox,
	handleFileSelect,
	hanlePdfSelect,
	onhandleImageChange,
	onhandlePdfFileChange
} from '../../assets/js/custome';

import {
	ChatBoxCloseIcon,
	ChatEmojiPicker,
	ChatImagePicker,
	ChatPdfPicker,
	ChatSendIcon
} from '../../assets/svg/icons';

import { addMessagesToGroup } from '../../services/actions/chat/addChatGroupMessagesActions';
import { fecthAllGroupPreviousMessages } from '../../services/actions/chat/getChatPreviousMessagesActions';
import { useCustomSelectors } from '../../services/selectors/allSelectors';
import { initatedGroupId } from '../../storage';
import { renderMessagesByDate } from '../../utils/helper/chatsHelper';
import { initiatedChatGroup } from '../../services/actions/chat/initiateChatGroupActions';
import { ReplayOutlined } from '@mui/icons-material';
import { ArrowLeft } from 'lucide-react';

import EmojiPicker from "emoji-picker-react";
import ChatLoader from '../common/chatLoader';

const getValidPhoto = (photo) => {
	const value = String(photo || '').trim();
	return value && !['null', 'undefined'].includes(value.toLowerCase()) ? value : '';
};

const getInitials = (value) => {
	const name = String(value || '').trim();
	if (!name) return 'U';

	const parts = name.split(/\s+/).filter(Boolean);
	if (parts.length === 1) {
		return parts[0].slice(0, 2).toUpperCase();
	}

	return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase();
};

const InitatedChatBox = ({ value,
	selectedEmployeeId,
	employeesOnlineStatus,
	setMyInputMessages,
	setAllGroupMessages,
	setChatInput,
	allGroupMessages,
	chatInput,
	myInputMessages,
	chatAppenedMessages,
	openOverlay,
	setSelectedEmployeeId,
	setPage,
	page,
	inline = false,
	onBack
}) => {

	const dispatch = useCustomDispatch()

	const chatBodyRef = useRef(null);

	const chatGroupID = initatedGroupId()

	const [isVisible, setIsVisible] = useState(false);
	const [scrolling, setScrolling] = useState(false);

	const currentTime = getCurrentTimeCanada();

	const {
		mediaFile,
		setMediaFile,
		mediaPdf,
		setMediaPdf
	} = useCustomDataStoringStates()

	const {
		loadGroupMessages,
		setLoadGroupMessages,
		showEmojiLoader,
		setShowEmojiLoader
	} = useCustomLoadingStates()

	const {
		profileData,
		pharmacyIntiatedChatResponse,
		initatedChatMessagesResponse,
	} = useCustomSelectors()

	const pagination = pharmacyIntiatedChatResponse?.data?.data?.pagination
	const [headerAvatarFailed, setHeaderAvatarFailed] = useState(false);

	const headerAvatarUrl = getValidPhoto(
		employeesOnlineStatus?.pharmacistUser?.photo
		|| employeesOnlineStatus?.driverUser?.photo
		|| employeesOnlineStatus?.photo
	);
	const headerDisplayName = employeesOnlineStatus?.name
		|| employeesOnlineStatus?.pharmacistUser?.name
		|| employeesOnlineStatus?.driverUser?.name
		|| 'User';
	const shouldShowHeaderAvatarImage = headerAvatarUrl && !headerAvatarFailed;

	const handleScroll = async () => {
		const chatBody = chatBodyRef.current;

		if (chatBody.scrollTop === 0) {
			await loadPreviousMessages();
		}
	}

	const handleChatMessages = async (e) => {
		setChatInput(e.target.value)
	}

	function handleEmojies(emojiData) {
		setChatInput((chatInput) => chatInput + (emojiData.isCustom ? emojiData.unified : emojiData.emoji))
	}

	const submitMessages = async (e, value, mediaFile) => {
		e.preventDefault()

		if ((chatInput || mediaFile?.length !== 0 || mediaPdf?.length !== 0) && chatGroupID) {
			dispatch(addMessagesToGroup(chatInput, 'text', chatGroupID, mediaFile, mediaPdf))
			setMyInputMessages([...myInputMessages, { message: chatInput, sender: 'user', time: currentTime, message_media: mediaFile, media_pdf: mediaPdf }])
			setChatInput('')
			setMediaFile([])
			setMediaPdf([])
		}
	}

	const chatkeyPress = (e, value) => {
		if (e.key === 'Enter') {
			submitMessages(e, value, mediaFile)
		}
	}

	const handleFileChange = (event) => {
		onhandleImageChange(event, setMediaFile, mediaFile)
	}

	const handlePdfFileChange = (event) => {
		onhandlePdfFileChange(event, setMediaPdf, mediaPdf)
	}

	useEffect(() => {
		setAllGroupMessages(initatedChatMessagesResponse)
	}, [pharmacyIntiatedChatResponse])

	useEffect(() => {
		if (chatBodyRef.current) {
			chatBodyRef.current.scrollTop = chatBodyRef.current.scrollHeight;
		}
	}, [myInputMessages,
		initatedChatMessagesResponse,
		chatAppenedMessages,
	])

	const messages = allGroupMessages && Object?.values(allGroupMessages)?.flat()

	useEffect(() => {
		if (!pharmacyIntiatedChatResponse?.loading && chatBodyRef?.current && messages && messages?.length <= 100) {
			chatBodyRef.current.scrollTop = chatBodyRef.current.scrollHeight;
		}
	}, [allGroupMessages])

	useEffect(() => {
		if (chatBodyRef.current) {
			chatBodyRef.current.scrollTop = chatBodyRef.current.scrollHeight;
		}
	}, [myInputMessages, chatAppenedMessages])

	useEffect(() => {
		setHeaderAvatarFailed(false);
	}, [headerAvatarUrl, selectedEmployeeId])

	const handleRemoveImage = (indexToRemove) => {
		const updatedMediaFiles = mediaFile.filter((_, index) => index !== indexToRemove);
		setMediaFile(updatedMediaFiles);
	};

	const handleRemovePdf = (indexToRemove) => {
		const updatedMediaFiles = mediaPdf?.filter((_, index) => index !== indexToRemove);
		setMediaPdf(updatedMediaFiles);
	}

	// useEffect(() => {
	// 	let timeoutId;

	// 	const handleScroll = () => {
	// 		if (chatBodyRef.current) {
	// 			setIsVisible(true);
	// 			setScrolling(true);
	// 			clearTimeout(timeoutId);
	// 			timeoutId = setTimeout(() => {
	// 				setIsVisible(false);
	// 				setScrolling(false);
	// 			}, 1000000);
	// 		}
	// 	};

	// 	if (chatBodyRef.current) {
	// 		chatBodyRef.current.addEventListener('scroll', handleScroll);
	// 	}

	// 	return () => {
	// 		if (chatBodyRef.current) {
	// 			chatBodyRef.current.removeEventListener('scroll', handleScroll);
	// 		}
	// 		clearTimeout(timeoutId);
	// 	};
	// }, [chatBodyRef.current]);

	// useEffect(() => {
	// 	if (selectedEmployeeId?.length) {
	// 		setGroupUsers(chatUserList?.data?.data?.filter((item) => selectedEmployeeId?.includes(item.user_id)))
	// 	}
	// }, [selectedEmployeeId])


	const loadPreviousMessages = async () => {

		const messages = allGroupMessages && Object?.values(allGroupMessages)?.flat()
		const lastMessageId = messages?.length > 0 ? messages[0]?.id : null;

		const requestedData = {
			group_type: 'one_to_one',
			user_id: [selectedEmployeeId],
			page: page
		}

		if (chatGroupID && page <= pagination?.last_page && lastMessageId) {
			await fecthAllGroupPreviousMessages(setAllGroupMessages, allGroupMessages, setLoadGroupMessages, chatBodyRef, requestedData);
			setPage(prevPage => prevPage + 1);
		}
	}

	const closeConversation = () => {
		if (onBack) {
			onBack();
			return;
		}
		closeChatbox(setSelectedEmployeeId);
	}

	return (
		<>
			{

				selectedEmployeeId ?
					<>
						<div
							className={inline ? 'chat-inline-detail' : 'fixed-chatbox z-50 rounded-none shadow-2xl'}
							id={inline ? undefined : 'fixedChatbox'}
							style={inline ? {
								display: selectedEmployeeId ? 'flex' : 'none',
							} : {
								display: selectedEmployeeId ? 'block' : 'none',
								border: '1px solid #e1e1e1',
								borderRadius: '8px'
							}}
						>

							<div className={inline ? 'support-chat-pane-header support-chat-pane-header--compact chat-inline-pane-header' : 'chatbox__header h-14 bg-white border z-30 flex flex-wrap items-center gap-2'} style={{ background: 'white' }}>
								{inline && (
									<button type="button" onClick={closeConversation} aria-label="Back to conversations">
										<ArrowLeft size={16} />
									</button>
								)}
								<h3 className={`flex flex-1 items-center gap-3 dark-color rubik-400 ${inline ? 'chat-inline-title' : 'fs-18'}`}>
									<div className={`support-chat-list-avatar ${inline ? 'chat-inline-header-avatar' : ''}`}>
										{shouldShowHeaderAvatarImage ? (
											<img
												className="bg-light object-cover"
												src={headerAvatarUrl}
												onError={() => setHeaderAvatarFailed(true)}
												alt="Rounded avatar"
											/>
										) : (
											<span className="support-chat-list-avatar-fallback">
												{getInitials(headerDisplayName)}
											</span>
										)}

										{
											pharmacyIntiatedChatResponse?.loading ? null :
												employeesOnlineStatus?.group_type === 'one_to_many' ? null :
													employeesOnlineStatus?.online_status === 'online' ?
														<span className="support-chat-list-avatar-dot online"></span>
														:
														employeesOnlineStatus?.online_status === 'offline' ?
															<span className="support-chat-list-avatar-dot offline"></span>
															:
															employeesOnlineStatus?.online_status === 'idle' ?
																<span className="support-chat-list-avatar-dot idle"></span>
																: null
										}

									</div>
									<span className={`${inline ? 'text-sm' : 'fs-18'} font-medium`}>{headerDisplayName}</span>
								</h3>
								{/* {
									(groupUsers?.length > 1) ?
										(<div className='flex flex-wrap '>
											{
												groupUsers.slice(0, 3).map(user => (
													<a className='btnnn hover-trigger relative -ml-4' key={user?.user_id}>
														<Avatar image={user?.thumbnail || null} name={user?.name} />
														<span className="hover-target text-nowrap w-32 text-gray-500 right-0 absolute z-50 top-12 transition-all rounded bg-white p-2 text-md  shadow-md">{user?.name}</span>
													</a>
												))
											}
											{
												groupUsers?.length > 3 ? (
													<a className='btnnn relative hover-trigger -ml-4'>
														<Avatar text={`+ ${groupUsers?.length - 3}`} />
														<ul className="hover-target z-10 shadow-md right-0 absolute top-11 w-48 text-sm font-medium text-gray-900 bg-white border 
																		border-gray-200 rounded-lg dark:bg-gray-700 dark:border-gray-600 dark:text-white">
															{
																groupUsers?.slice(3, groupUsers?.length).map(user => (

																	<li key={user?.user_id} className="w-full  text-gray-500 flex gap-2 items-center px-2 py-2 border-b border-gray-200 rounded-t-lg 
																										dark:border-gray-600">
																		<Avatar name={user?.name} image={user?.thumbnail} />
																		<span className='flex-1'>
																			{user?.name}
																		</span>
																	</li>
																))
															}
														</ul>
													</a>
												) : null
											}
										</div>) : null
								} */}
								{!inline && (
									<div className="js-chatbox-toggle flex items-center gap-4">
										<button onClick={closeConversation}>
											<ChatBoxCloseIcon />
										</button>
									</div>
								)}
							</div>

							<div className={inline ? 'scroll-box relative chat-inline-messages' : 'scroll-box relative'} ref={chatBodyRef} onScroll={handleScroll} style={{ background: inline ? undefined : 'white', height: inline ? undefined : '390px', overflowY: 'auto' }}>

								{
									loadGroupMessages &&
									<div className="flex items-center justify-center  mt-2">
										<div className="flex items-center">
											<ChatLoader />
										</div>
									</div>
								}

								{pharmacyIntiatedChatResponse?.loading && (
									<div className="support-chat-loading">Loading conversation...</div>
								)}

								{renderMessagesByDate(allGroupMessages, profileData, value, openOverlay, scrolling, isVisible, chatBodyRef, employeesOnlineStatus)}


								{
									chatAppenedMessages?.length === 0 ? null :
										chatAppenedMessages?.map((msglist, index) => {
											return (
												<React.Fragment key={index}>
													{
														msglist?.user_id === selectedEmployeeId && <>

															{
																msglist?.last_message === null ? null :
																	<SenderTextMessages profileData={profileData} textMessage={msglist?.last_message} time={msglist?.message_time?.slice(12)} />
															}

															{
																msglist?.message_media?.length === 0 ? null :
																	<>
																		{msglist.message_media?.map((msgListImage, index) => {
																			return (
																				<React.Fragment key={index}>
																					<SenderImageMessage profileData={profileData} image={msgListImage} openOverlay={openOverlay} time={msglist?.message_time?.slice(12)} />
																				</React.Fragment>
																			)
																		})}
																	</>
															}

															{
																msglist?.media_pdf?.length === 0 ? null : <>{
																	msglist?.media_pdf?.map((pdf, index) => {
																		return (
																			<React.Fragment key={index}>
																				<PdfSenderMessages profileData={profileData} pdf={pdf} time={msglist?.message_time?.slice(12)} />
																			</React.Fragment>
																		)
																	})
																}
																</>
															}

														</>
													}

													{
														msglist?.user_id !== selectedEmployeeId && <>
															{
																msglist?.message_text === null ? null :
																	<ReceiverTextMessages chatUser={value} textMessage={msglist.last_message}
																		time={msglist?.message_time?.slice(12)} data={msglist}
																		selectedData={employeesOnlineStatus} />
															}

															{
																msglist?.message_media?.length === 0 ? null : <>
																	{
																		msglist?.message_media?.map((msgListImage, index) => {
																			return (
																				<React.Fragment key={index}>
																					<RecevicerImageMessage chatUser={value} time={msglist?.message_time?.slice(12)} openOverlay={openOverlay} image={msgListImage} data={msglist}
																						selectedData={employeesOnlineStatus} />
																				</React.Fragment>
																			)
																		})
																	}</>
															}

															{
																msglist?.media_pdf?.length === 0 ? null : <>{
																	msglist?.media_pdf?.map((pdfFile, index) => {
																		return (
																			<React.Fragment key={index}>
																				<PDFReceiverMessages chatUser={value} pdf={pdfFile} time={msglist?.message_time?.slice(12)} data={msglist}
																					selectedData={employeesOnlineStatus} />
																			</React.Fragment>
																		)
																	})
																}
																</>
															}

														</>
													}

												</React.Fragment>
											)
										})
								}

								{
									(profileData?.user_id !== value?.user_id) && <>
										{myInputMessages?.map((msg, index) => {
											return (<React.Fragment key={index}>
												{
													msg.message === '' ? null :
														<SenderTextMessages profileData={profileData} textMessage={msg?.message} time={msg?.time} />
												}

												{
													msg?.message_media?.length === 0 ? null : <>{
														msg?.message_media?.map((image, index) => {
															return (
																<React.Fragment key={index} >
																	<SenderImageMessage profileData={profileData} image={URL?.createObjectURL(image)} openOverlay={openOverlay} time={msg.time} />
																</React.Fragment>
															)
														})
													}
													</>
												}

												{
													msg?.media_pdf?.length === 0 ? null : <>{
														msg?.media_pdf?.map((pdf, index) => {
															return (
																<React.Fragment key={index}>
																	<PdfSenderMessages time={msg?.time} profileData={profileData} pdf={pdf} />
																</React.Fragment>
															)
														})
													}
													</>
												}

											</React.Fragment>)
										})
										}
									</>
								}
							</div>

							<div className={inline ? 'support-chat-composer-footer chat-inline-footer w-full z-20' : 'chat-footer absolute bottom-0 w-full z-20'} style={{ borderBottomLeftRadius: '10px', borderBottomRightRadius: '10px' }}>
								{pharmacyIntiatedChatResponse?.error !== null &&
									<div className="flex items-center justify-center max-w-md  bg-white bg-opacity-80">
										<div className='p-2'>
											<h2 className="text-lg font-bold text-red-500">🛠️ Oops!</h2>
											<p className="text-md text-gray-700">Looks like we hit a snag. Hang tight while we sort things out! </p>
										</div>
										<button onClick={() => dispatch(initiatedChatGroup('one_to_one', value.user_id, null))}
											className="flex justify-center items-center text-red-600 p-2"><ReplayOutlined /></button>
									</div>
								}

								<div className={inline ? 'support-chat-composer chat-inline-composer' : 'relative bg-white border-t'}>
									<textarea id="message" value={chatInput} onKeyPress={(e) => chatkeyPress(e, value)} rows={inline ? 1 : 4} onChange={handleChatMessages}
										className={inline ? 'support-chat-composer-input chat-inline-composer-input rubik-400' : 'rubik-400 fs-16 block mt-10 p-2.5 w-full text-sm text-gray-900 scroll-box resize-none border-none focus:ring-transparent focus:border-transparent'}
										placeholder="Write message...">
									</textarea>

									{(mediaFile?.length !== 0 || mediaPdf?.length !== 0) ? (
										<div className="image-container" style={{ display: 'flex', flexWrap: 'wrap' }}>
											{mediaFile?.map((value, index) => (
												<div key={index} style={{ position: 'relative' }}>
													<div className="close-btn"
														style={{ position: 'absolute', zIndex: '999999', right: '5px', top: '5px', cursor: 'pointer' }}
														onClick={() => handleRemoveImage(index)}>
														×
													</div>
													<img
														style={{ position: 'relative', }}
														src={URL.createObjectURL(value)}
														alt="Selected"
														className='rounded-2 h-12 w-12 m-2'
													/>
												</div>
											))}
											{mediaPdf?.map((value, index) => {
												return (
													<a className="btnnn rubik-400 fs-16 m-2 dark-color uppercase red-color underline flex gap-2" key={index}>
														<div className='relative'>
															<div className="close-btn" style={{
																position: 'absolute', right: '-1px', top: '-2px', cursor: 'pointer', color: 'black',
																borderColor: 'black'
															}}
																onClick={() => handleRemovePdf(index)}>
																×
															</div>
															<svg width="50" height="50" viewBox="0 0 20 22" fill="none" xmlns="http://www.w3.org/2000/svg">
																<g clipPath="url(#clip0_57_2-751433)">
																	<path d="M19.9021 6.47316L13.7129 0.10102C13.6501 0.0365918 13.5655 0 13.477 0H6.46633C4.8347 0 3.50728 1.36692 3.50728 3.04655V9.07545H0.910023C0.408235 9.07545 0 9.49569 0 10.0122V15.3971C0 15.9136 0.408235 16.3339 0.910023 16.3339H3.50707V18.9537C3.50728 20.6331 4.83448 22 6.46633 22H17.041C18.6726 22 20 20.6331 20 18.9534V6.71651C19.9998 6.62537 19.9647 6.53759 19.9021 6.47316ZM3.00179 14.5478V10.8624C3.00179 10.6725 3.15117 10.5187 3.33566 10.5187H4.41142C5.1882 10.5187 5.82061 11.1697 5.82061 11.9693V12.0158C5.82061 12.8159 5.1882 13.4665 4.41142 13.4665H3.66931V14.5481C3.66931 14.738 3.51993 14.8918 3.33588 14.8918C3.15117 14.8918 3.00179 14.7378 3.00179 14.5478ZM6.59761 14.5478V10.8624C6.59761 10.6725 6.74699 10.5187 6.93104 10.5187H8.0068C8.78402 10.5187 9.416 11.1697 9.416 11.9693V13.4411C9.416 14.2407 8.78402 14.8918 8.0068 14.8918H6.93104C6.74721 14.8918 6.59761 14.7378 6.59761 14.5478ZM12.4782 12.1584C12.6627 12.1584 12.8121 12.3121 12.8121 12.5016C12.8121 12.6915 12.6627 12.8453 12.4782 12.8453H10.927V14.5478C10.927 14.7378 10.7777 14.8915 10.5936 14.8915C10.4091 14.8915 10.2597 14.7378 10.2597 14.5478V10.8624C10.2597 10.6725 10.4091 10.5187 10.5936 10.5187H12.7445C12.9285 10.5187 13.0779 10.6725 13.0779 10.8624C13.0779 11.0519 12.9285 11.2056 12.7445 11.2056H10.927V12.1581L12.4782 12.1584ZM19.3325 18.9534C19.3325 20.2546 18.3045 21.3128 17.041 21.3128H6.46633C5.20281 21.3128 4.17481 20.2546 4.17481 18.9534V16.3337H15.169C15.6708 16.3337 16.079 15.9134 16.079 15.3969V10.0122C16.079 9.49569 15.6708 9.07545 15.169 9.07545H4.17459V3.04655C4.17459 1.74541 5.20259 0.687163 6.46611 0.687163H13.1429V6.02822C13.1429 6.59708 13.5921 7.05998 14.1438 7.05998H19.3323L19.3325 18.9534ZM4.41142 12.7793H3.66931V11.2059H4.41142C4.82053 11.2059 5.15309 11.5484 5.15309 11.9693V12.0158C5.15309 12.437 4.82031 12.7793 4.41142 12.7793ZM8.0068 14.2046H7.26513V11.2059H8.0068C8.41591 11.2059 8.74847 11.5484 8.74847 11.9693V13.4411C8.74869 13.8622 8.41591 14.2046 8.0068 14.2046Z" fill="#FA3737" />
																</g>
																<defs>
																	<clipPath id="clip0_57_2-751433">
																		<rect width="20" height="22" fill="white" />
																	</clipPath>
																</defs>
															</svg>
														</div>
													</a>
												)
											})}
										</div>
									) : null}

									<div className={inline ? 'support-chat-tools inline-tools chat-inline-tools' : 'absolute left-4 top-2 flex items-start gap-4 w-full'}>

										<button type="button" className={inline ? 'chat-inline-tool-button' : ''} onClick={handleFileSelect} title="Attach image">
											<ChatImagePicker />
										</button>

										<input id="chatFileInput" accept="image/*" type="file" style={{ display: 'none' }} onChange={handleFileChange} />

										<button type="button" className={inline ? 'chat-inline-tool-button' : ''} onClick={hanlePdfSelect} title="Attach PDF">
											<ChatPdfPicker />
											<input type="file" accept="application/pdf" multiple id="chatPdfInput" style={{ display: 'none' }} onChange={handlePdfFileChange} />
										</button>

										<button type="button" className={inline ? 'chat-inline-tool-button' : ''} onClick={() => setShowEmojiLoader(!showEmojiLoader)} title="Emoji">
											<ChatEmojiPicker />
										</button>

										<button type="button" className={inline ? 'support-chat-send-btn chat-inline-send-button' : 'absolute right-6 top-0'} onClick={(e) => submitMessages(e, value, mediaFile)} title="Send" aria-label="Send message">
											<ChatSendIcon />
										</button>

									</div>

									{/* <div className="flex items-center gap-4 p-3 footerIcon border-t" style={{ background: '#f4f5f6', borderBottomLeftRadius: '10px', borderBottomRightRadius: '10px' }}>

									<button onClick={handleFileSelect}>
										<ChatImagePicker />
									</button>

									<input id="chatFileInput" accept="image/*" type="file" style={{ display: 'none' }} onChange={handleFileChange} />

									<button onClick={hanlePdfSelect}>
										<ChatPdfPicker />
										<input type="file" accept="application/pdf" multiple id="chatPdfInput" style={{ display: 'none' }} onChange={handlePdfFileChange} />
									</button>

									<button onClick={() => setShowEmojiLoader(!showEmojiLoader)}>
										<ChatEmojiPicker />
									</button>

								</div> */}

									{
										showEmojiLoader && <EmojiPicker searchDisabled onEmojiClick={handleEmojies} height={208} lazyLoadEmojis={true} width={379} className="custom-emoji-picker" />
									}

								</div>
							</div>
						</div>

					</> : null
			}
		</>
	)
}

export default InitatedChatBox
